export default __webpack_public_path__ + "static/media/Thumbnail2.61db2908.jpg";